import { faker } from '@faker-js/faker';

const common = {
  'https://brighte.com.au/roles': ['CLIENT'],
  role: 'CLIENT',
  userId: faker.string.alphanumeric(),
  iss: faker.internet.url(),
  aud: faker.string.alphanumeric(),
  iat: new Date().getTime(),
  sub: faker.string.alphanumeric(),
};

export const accessToken = {
  id: faker.string.alphanumeric(),
  scope:
    'openid profile phone email create:finance-applications-from-quote read:finance-applications update:finance-applications update:finance-applicants read:finance-quotes write:payment-methods',
  gty: faker.string.alphanumeric(),
  azp: faker.string.alphanumeric(),
  ...common,
};

export const idToken = {
  id: 'U133781',
  uid: 'abc-1234',
  given_name: faker.person.firstName(),
  family_name: faker.person.lastName(),
  nickname: faker.person.firstName(),
  name: faker.person.fullName(),
  picture:
    'https://s.gravatar.com/avatar/8d138169d4db7009ec531d64a29696c6?s=480&r=pg&d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2F6.png',
  updated_at: '2024-04-10T04:30:57.272Z',
  phone_number: faker.helpers.replaceSymbols('041#######'),
  email: faker.internet.email(),
  email_verified: false,
  ...common,
};

export const mockErrors = {
  INVALID_CODE: 'Wrong phone number or verification code.',
  MAX_ATTEMPT: `You've reached the maximum number of attempts. Please try to login again.`,
  VERIFICATION_ERROR_INCORRECT_CODE: 'Your verification code is incorrect, please try again',
  VERIFICATION_ERROR_MAX_ATTEMPTS: `You've reached your maximum attempts. Please request a new code`,
};

export const mockAuthError = (path, code) => {
  return [
    {
      message: '403: Forbidden',
      locations: [
        {
          line: 3,
          column: 3,
        },
      ],
      path: [path],
      extensions: {
        code: 'FORBIDDEN',
        response: {
          url: 'test.com',
          status: 403,
          statusText: 'Forbidden',
          body: {
            code: mockErrors[code],
          },
        },
      },
    },
  ];
};

export const mockVerifyUpdate = (path, code) => {
  return [
    {
      message: mockErrors[code],
      path: [path],
      extensions: {
        code: code,
      },
    },
  ];
};
